import { BudgetAPI, ExpenseAPI } from 'src/api'
import { capitalize } from 'src/utils/common'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async updateTargetBudget(context, { id, targetBudget }) {
      const data = await ExpenseAPI.updateTargetBudget({ id, targetBudget })
      return data
    },
    async updateActualBudget(context, { id, actualBudget }) {
      const data = await ExpenseAPI.updateActualBudget({ id, actualBudget })
      return data
    },
    async updateProduct({ rootState }, { productId, expensesPercents, price, userParams = {} }) {
      const budgetType = rootState.budget.budgetType
      const data = await ExpenseAPI.updateProduct({
        productId,
        expensesPercents,
        price,
        ...userParams,
        [`total${capitalize(budgetType)}`]: price,
      })
      return data
    },
    async deleteCategory({ rootState }, body = {}) {
      const { dealerShipId } = rootState.settings
      if (+dealerShipId === 0) {
        const data = await BudgetAPI.deleteCategory({ ...body })
        return data
      }

      const data = await ExpenseAPI.deleteCategory({ ...body })
      return data
    },
    async deleteProduct({ rootState }, body = {}) {
      const { dealerShipId } = rootState.settings
      if (+dealerShipId === 0) {
        const data = await BudgetAPI.deleteProduct({ ...body })
        return data
      }

      const data = await ExpenseAPI.deleteProduct({ ...body })
      return data
    },

    async deleteCampaign(_, body = {}) {
      const data = await BudgetAPI.deleteCampaign({ ...body })
      return data
    },
    async create(_, { body, userParams = {} }) {
      const { dealerShipId } = userParams
      const data = await ExpenseAPI.create({ ...body, dealerShipId })
      return data
    },
    async findExpenses(_, body) {
      const data = await ExpenseAPI.find({ ...body })
      return data
    },
    async get(_, id) {
      const data = await ExpenseAPI.get({ id })
      return data
    },
    async update(_, { body }) {
      const data = await ExpenseAPI.update({ ...body })
      return data
    },
    async remove(_, { id }) {
      const data = await ExpenseAPI.delete({ id })
      return data
    },
    async getInvoices(_, id) {
      const data = await ExpenseAPI.getInvoices({ id })
      return data
    },
    async deleteInvoice(_, { fileId, id }) {
      const data = await ExpenseAPI.deleteInvoice({ fileId, id })
      return data
    },
    async addInvoice(_, { fileId, id }) {
      const data = await ExpenseAPI.addInvoice({ fileId, id })
      return data
    },
  },
  getters: {},
}
